import { observable, action } from 'mobx';
import { IAppConfig } from '@estee/elc-universal-utils';

export class ConfigStore {
    @observable public config: IAppConfig = {};

    constructor(config: IAppConfig) {
        this.updateConfig(config);
    }

    @action
    public updateConfig(config: IAppConfig) {
        this.config = { ...config };
    }
}
